import { Theme, createStyles } from "@material-ui/core";

export const styles = ({ spacing }: Theme) => createStyles({
    container: {
        marginRight: spacing.unit * 6,
        marginLeft: spacing.unit * 6,
        marginBottom: (spacing.unit * 10)
    }
});


// WEBPACK FOOTER //
// ./src/components/Statistics/Statistics.style.tsx